import { MODAL_TYPES, type ModalType } from './constants';

/**
 * Map of modal types to user-friendly loading messages.
 * These messages provide context about what's being loaded.
 */
const MODAL_LOADING_MESSAGES: Record<ModalType, string> = {
  // Onboarding modals
  [MODAL_TYPES.PATIENT_COMMUNICATION_ONBOARDING]: 'Loading onboarding...',

  // Feature modals
  [MODAL_TYPES.NEW_FEATURE]: 'Loading feature details...',
  [MODAL_TYPES.VERSION_UPDATE]: 'Loading version update...',
  [MODAL_TYPES.ENABLE_EHR_MODE]: 'Loading EHR settings...',

  // Patient modals
  [MODAL_TYPES.NEW_PATIENT]: 'Loading patient form...',
  [MODAL_TYPES.PATIENT_INFO_COLLECTION]: 'Loading patient information...',

  // Payment modals
  [MODAL_TYPES.STRIPE_CONNECT_INFO]: 'Loading payment setup...',
  [MODAL_TYPES.PAYMENT_REQUEST]: 'Loading payment request...',

  // Toolbar action modals
  [MODAL_TYPES.SEND_COMMUNICATION]: 'Preparing message composer...',
  [MODAL_TYPES.LAB_ORDER]: 'Loading lab order form...',
  [MODAL_TYPES.GENERATE_DOCUMENT]: 'Loading document generator...',
  [MODAL_TYPES.REQUEST_PAYMENT]: 'Loading payment request form...',

  // Document viewer modals
  [MODAL_TYPES.PDF_VIEWER]: 'Loading document viewer...',

  // Other modals
  [MODAL_TYPES.FIX_SPELLING]: 'Loading spell checker...',
  [MODAL_TYPES.JOTDOC_FIND_REPLACE]: 'Loading find/replace...',
  [MODAL_TYPES.COPY_PASTE_PREFERENCES]: 'Loading preferences...',

  // Consent modals
  [MODAL_TYPES.CONSENT_INFORMATION]: 'Loading consent information...',

  // Appointment selection modal
  [MODAL_TYPES.APPOINTMENT_SELECTION]: 'Checking appointments...',

  // Appointment types management modal
  [MODAL_TYPES.APPOINTMENT_TYPES_MANAGEMENT]: 'Loading appointment types...',

  // JotCoach feedback modal
  [MODAL_TYPES.JOTCOACH_FEEDBACK]: 'Loading feedback form...',

  // Approval modal
  [MODAL_TYPES.APPROVAL_MODAL]: 'Loading approval review...',

  // Notepad modal
  [MODAL_TYPES.NOTEPAD]: 'Loading notepad...',

  // Medication timeline modal
  [MODAL_TYPES.MEDICATION_TIMELINE]: 'Loading medication timeline...',

  // CSAT modal
  [MODAL_TYPES.CSAT]: 'Loading feedback form...',

  // Rule detail modal
  [MODAL_TYPES.RULE_DETAIL]: 'Loading rule details...',

  // Rule drilldown modal
  [MODAL_TYPES.RULE_DRILLDOWN]: 'Loading rule audits...',

  // Entitlement modals
  [MODAL_TYPES.ENTITLEMENT_CONTACT_ADMIN]: 'Loading...',

  // Insurance management modal
  [MODAL_TYPES.INSURANCE_EDIT]: 'Loading insurance information...',

  // System notification modal
  [MODAL_TYPES.SYSTEM_NOTIFICATION]: 'Loading notification...',

  // JotAudit video modal
  [MODAL_TYPES.JOTAUDIT_VIDEO]: 'Loading video...',
};

/**
 * Get the loading message for a specific modal type.
 * Falls back to a generic message if type not found.
 */
export const getModalLoadingMessage = (modalType: ModalType): string => {
  return MODAL_LOADING_MESSAGES[modalType] || 'Loading...';
};

export default MODAL_LOADING_MESSAGES;
